import moment from 'jalali-moment';
import '../../../style/mobile/store/MspTab2.scss';
import icon1 from '../../../../assets/mobile/azmoon-list/vuesax-linear-stickynote.svg'
import icon2 from '../../../../assets/azmoon-list/vuesax-linear-teacher2.svg'
import icon3 from '../../../../assets/mobile/azmoon-list/vuesax-linear-clock.svg'
import icon4 from '../../../../assets/mobile/azmoon-list/vuesax-linear-message-minus.svg'
import icon5 from '../../../../assets/mobile/azmoon-list/vuesax-linear-message-text.svg'
import icon6 from '../../../../assets/mobile/azmoon-list/vuesax-linear-people.svg'
import icon7 from '../../../../assets/mobile/azmoon-list/vuesax-linear-profile-2user.svg'
import icon8 from '../../../../assets/mobile/azmoon-list/vuesax-linear-message-text-2.svg'
import img2 from '../../../../assets/mobile/azmoon-list/anton-sukhinov-_C2A8THeKKs-unsplash (1).png'
import { Link } from 'react-router-dom';


const MspTab2=({data})=>{
  // const state = useSelector((state) => state.default);
  // let data;
  // for (let i = 0; i < state.ExamData.length; i++) {
  //   if (state.ExamData[i].id === Number(ID)) {
  //     data = state.ExamData[i];
  //   }
  // }

  return(
    <div className="MspTab2">
      <div className="MspTab2-item">
        <img src={icon1} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">نام آزمون:</div>
        <div className="MspTab2-item-value">{data.name}</div>
      </div>
      <div className="MspTab2-item">
        <img src={icon2} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">پایه تحصیلی:</div>
        <div className="MspTab2-item-value">{data.level}</div>
      </div>
      <div className="MspTab2-item">
        <img src={icon3} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">زمان آزمون:</div>
        <div className="MspTab2-item-value MspTab2-item-value-date">
            {moment(data?.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
            ساعت 
            {moment(data?.date, 'YYYY/MM/DD HH:mm').locale("fa").format('HH:mm')}
        </div>
      </div>
      <div className="MspTab2-item">
        <img src={icon4} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">نمره منفی:</div>
        <div className="MspTab2-item-value">
          {data.negattiveMode && "دارد"}
          {!data.negattiveMode && "ندارد"}
        </div>
      </div>
      <div className="MspTab2-item">
        <img src={icon5} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">نوع سوالات:</div>
        <div className="MspTab2-item-value">
          {data.types}
        </div>
      </div>
      <div className="MspTab2-item">
        <img src={icon6} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">حدنصاب شرکت کنندگان:</div>
        <div className="MspTab2-item-value">{data.capacity} نفر</div>
      </div>
      <div className="MspTab2-item">
        <img src={icon7} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">نوع شرکت در آزمون:</div>
        <div className="MspTab2-item-value">
          {data.type && "انفرادی"}
          {!data.type && "گروهی"}
        </div>
      </div>
      <div className="MspTab2-item">
        <img src={icon8} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">فایل راهنما:</div>
        <div className="MspTab2-item-value">
          {data.guideFileId && "دارد"}
          {!data.guideFileId && "ندارد"}
           - <Link className="MspTab2-item-value-link" to={data.guideFileId}>مشاهده فایل</Link>
        </div>
      </div>
      <div className="MspTab2-item">
        <img src={img2} alt="name-icon" className="MspTab2-item-icon"/>
        <div className="MspTab2-item-title">ایجاد شده توسط:</div>
        <div className="MspTab2-item-value">{data.creator.name}</div>
      </div>
    </div>
  )
}

export default MspTab2;